
import { actionType } from "../auth/action";
import { put, takeEvery } from 'redux-saga/effects';
import api from '../../services/API';

function* checkLoginAuth() {
  try {
    // uncomment for prod/uat/dev/sqa and comment the below const auth    
    const auth = yield api.auth.checkAuth();

    // uncomment on local and comment for prod/uat/dev/sqa
    // const auth = {
    //   data: { 
    //     statusCode: 200,
    //     body: {
    //       message: "success",
    //       sessionId: "20191219092053378Y2zmoDJd5PZyKzNryvdYhvOOn7aYrY",
    //       userId: "3f0760ff428a"
    //     }
    //   }
    // }

    let isAppHeader = false;
    if (auth.headers && ('app-header' in auth.headers)) {
      isAppHeader = (auth.headers["app-header"] === 'true');
    }
    auth.data.body.isAppHeader = isAppHeader;
    if (auth.data.statusCode === 200 && auth.data && auth.data.body.message === 'success') {
      auth.data.body.isAuthenticated = true;
      yield put({ type: actionType.LOGIN_AUTH_SUCCESS, payload: auth.data.body });
    } else {
      auth.data.body.isAuthenticated = false;
      yield put({ type: actionType.LOGIN_AUTH_FAILURE, payload: auth.data.body });
    }
  } catch (exception) {
   
    yield put({ type: actionType.LOGIN_AUTH_FAILURE, payload: {} });    
  }



}
export const AuthSaga = [
  takeEvery(actionType.LOGIN_AUTH_REQUEST, checkLoginAuth)
]